const setTopOffset = offset => {
  return {
    type: 'SET_TOP_OFFSET',
    payload: offset
  }
}

export const addTopOffset = offset => (dispatch, getState) => {
  const updatedOffset = getState().topOffset + offset
  dispatch(setTopOffset(updatedOffset))
}

export const subtractTopOffset = offset => (dispatch, getState) => {
  const updatedOffset = getState().topOffset - offset
  dispatch(setTopOffset(updatedOffset))
}

export const clearTopOffset = () => (dispatch) => {
  dispatch(setTopOffset(0))
}